import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    // avis « Non publié » en attente de modération (alerte du menu)
    offlineReviewsCount: 0,
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
